import { Redirect, Route, Switch } from 'react-router-dom';

import routes, { PathsLayouts } from '../../config/routes';

type RoutesByLayoutProps = {
  pathLayout: PathsLayouts;
};

/**
 * Es utilizado para renderizar todas las rutas asociadas a un layout
 */
const RoutesByLayout = ({
  pathLayout,
}: RoutesByLayoutProps): JSX.Element | null => {
  const routesByLayout = routes[pathLayout];

  if (routesByLayout) {
    return (
      <Switch>
        {routesByLayout.views.map(({ path, component }, key) => {
          return (
            <Route
              path={pathLayout + path}
              component={component}
              key={key}
              exact
            />
          );
        })}

        <Redirect from="*" to={pathLayout + routesByLayout.defaultPath} />
      </Switch>
    );
  }
  return null;
};

export default RoutesByLayout;
